import t from "../../../locales/common.json";
import imageData from "../../../img/translations.svg";
import Featurette from "../../featurette/index.marko";
import FeaturetteBody from "../../featurette/body.marko";
import FeaturetteBodyText from "../../featurette/body-text.marko";
import FeaturetteHeading from "../../featurette/heading.marko";
import FeaturetteTitle from "../../featurette/title.marko";

static const link = "/translations";

<div>
  <enclosed-section>
    <Featurette>
      <FeaturetteHeading>
        <a href=link>
          <image-fluid src=imageData alt=t.cc.Services.translations.title/>
        </a>
      </FeaturetteHeading>
      <FeaturetteBody>
        <FeaturetteTitle>
          ${t.cc.Services.translations.title}${t.cc.Services.translations.subtitle}
        </FeaturetteTitle>
        <FeaturetteBodyText>
          <p>${t.cc.Services.translations.body}</p>
          <p>${t.cc.Services.translations.explanation}</p>
        </FeaturetteBodyText>
        <div class="flex justify-content-center justify-content-start-lg">
          <button-link style={ "max-width": "fit-content" } href=link>
            ${t.cc.Services.showMore}
          </button-link>
        </div>
      </FeaturetteBody>
    </Featurette>
  </enclosed-section>
</div>
